import PageCollection from 'zoomforth_zf/models/page.collection.js';

var singleton;


const init = function(data, opts) {
  singleton = new PageCollection(data, opts);
  return singleton;
};

const get = function() {
  if (!singleton) {
    throw new Error('You must call `init` on appglobal singleton before calling `get`');
  }
  return singleton;
};


export { get, init };
export default { get, init };
